import { createSelector } from 'reselect';

const selectView = state => state.view;

export const selectCurrentViewWithData = createSelector(
  [selectView],
  (view) => ({ currentView: view.currentView, viewData: view.viewData })
);